module.exports = {
      id: "menu-search-usage",
      viewBox: "0 0 28.943 16.863",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#menu-search",
      toString: function () {
        return this.url;
      }
    }